var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrafficLightSquare = function SvgTrafficLightSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 26.5,
    cy: 27.5,
    r: 24.5,
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 13,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    x: 6,
    y: 7,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    y: 14,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 29",
    y: 21,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    y: 28,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 31",
    y: 35,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32",
    x: 6,
    y: 42,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 38",
    x: 6,
    y: 42,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39",
    x: 40,
    y: 42,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40",
    x: 47,
    y: 35,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41",
    x: 47,
    y: 28,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 42",
    x: 47,
    y: 21,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 43",
    x: 47,
    y: 14,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 44",
    x: 41,
    y: 7,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34",
    x: 12,
    y: 49,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 35",
    x: 19,
    y: 49,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36",
    x: 26,
    y: 49,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 37",
    x: 33,
    y: 49,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    x: 20,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 27,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 34,
    width: 6,
    height: 6,
    fill: "#AAAAAA"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrafficLightSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/traffic-light-square.595804d7.svg";
export { ForwardRef as ReactComponent };